import numeral from 'numeral';

// ----------------------------------------------------------------------

type InputValue = string | number | null;

export function fNumber(number: InputValue) {
  return numeral(number).format();
}

export function fCurrency(number?: number | string) {
  if (!number) return '';

  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2,
  }).format(Number(number));
}


export function fPercent(number: InputValue) {
  const format = number ? numeral(Number(number) / 100).format('0.0%') : '';

  return result(format, '.0');
}

export function fShortenNumber(number: InputValue) {
  const format = number ? numeral(number).format('0.00a') : '';

  return result(format, '.00');
}

export function fData(number: InputValue) {
  const format = number ? numeral(number).format('0.0 b') : '';

  return result(format, '.0');
}

export function fPhone(phone: InputValue) {
  if (!phone) return '';

  // Garante que só vai ter dígitos
  let digits = String(phone).replace(/\D/g, '');

  // Remove código do país 55 se estiver presente
  if (digits.startsWith('55')) {
    digits = digits.slice(2);
  }

  if (digits.length === 10) {
    // Formato (XX) XXXX-XXXX
    return digits.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
  }

  if (digits.length === 11) {
    // Formato (XX) XXXXX-XXXX
    return digits.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
  }

  // Se não bater com 10 ou 11 dígitos, retorna bruto
  return digits;
}

export function fCpf(cpf: InputValue) {
  if (!cpf) return '';

  // Remove tudo que não for dígito
  const digits = String(cpf).replace(/\D/g, '');

  // Verifica se tem 11 dígitos (padrão CPF)
  if (digits.length !== 11) return digits; // retorna cru se não for 11

  // Formata
  return digits.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
}


function result(format: string, key = '.00') {
  const isInteger = format.includes(key);

  return isInteger ? format.replace(key, '') : format;
}
